// MindseedList.js
import React from 'react';
import ServicesSection from './ServicesSection';
import '../Style/Services.css';
import image1 from '../Images/WhatsApp Image 2025-04-28 at 2.31.04 PM.jpeg';
import image2 from '../Images/WhatsApp Image 2025-04-28 at 10.01.49 PM.jpeg'
import image3 from '../Images/WhatsApp Image 2025-04-28 at 12.21.37 PM.jpeg'
import image4 from '../Images/WhatsApp Image 2025-04-28 at 10.02.15 PM.jpeg'


const ServicesList = () => {
  const items = [
    {
      percentage: 96,
      imageSrc: image2,
      text: "PRESCHOOL AND NURSERY",
    },
    {
      percentage: 100,
      imageSrc: image1,
      text: "DAY-CARE CENTRE",
    },
    {
      percentage: 87,
      imageSrc: image3,
      text: "JUNIOR KG",
    },
    {
      percentage: 85,
      imageSrc: image4,
      text: "SENIOR KG",
    },
  ];

  return (
    <section id="services">
      <div className="container">
        <h2 className="section-title">Facilities</h2> {/* Add your heading here */}
        <div className="row">
          <div className="col-12">
            <div className="mindseed-list">
              {items.map((item, index) => (
                <ServicesSection
                  key={index}
                  percentage={item.percentage}
                  imageSrc={item.imageSrc}
                  text={item.text}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesList;
